var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMpegVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 304,
    viewBox: "0 0 239 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.821 0H0.841797V303.188H238.346V50.525L187.821 0Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.603 69.553H74.0918V178.26H163.603V69.553Z",
    fill: "#FF9900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.242 126.587H79.4536V172.9H158.242V126.587Z",
    fill: "#D1D3D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.242 74.9141H79.4536V121.226H158.242V74.9141Z",
    fill: "#D1D3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0926 69.553H60.2026V178.26H74.0926V69.553Z",
    fill: "#A4A9AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3075 167.872H63.4355V173.65H71.3075V167.872Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3075 154.485H63.4355V160.262H71.3075V154.485Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3075 141.098H63.4355V146.876H71.3075V141.098Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3075 127.711H63.4355V133.489H71.3075V127.711Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3075 114.323H63.4355V120.101H71.3075V114.323Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3075 100.936H63.4355V106.714H71.3075V100.936Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3075 87.5491H63.4355V93.3261H71.3075V87.5491Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3075 74.1609H63.4355V79.9389H71.3075V74.1609Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.493 69.553H163.604V178.26H177.493V69.553Z",
    fill: "#A4A9AD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174.259 167.872H166.387V173.65H174.259V167.872Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.259 154.485H166.387V160.262H174.259V154.485Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M174.259 141.098H166.387V146.876H174.259V141.098Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M174.259 127.711H166.387V133.489H174.259V127.711Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M174.259 114.323H166.387V120.101H174.259V114.323Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M174.259 100.936H166.387V106.714H174.259V100.936Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M174.259 87.5491H166.387V93.3261H174.259V87.5491Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M174.259 74.1609H166.387V79.9389H174.259V74.1609Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M195.64 25.263H0.841797V0H187.821L195.64 25.263Z",
    fill: "#FF9900"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5077 273.871L46.7477 243.021H46.4837C46.8937 248.275 47.0987 252.357 47.0987 255.267V273.871H36.8457V231.039H52.2557L61.1917 261.449H61.4257L70.1857 231.039H85.6247V273.871H74.9897V255.092C74.9897 254.115 75.0047 253.031 75.0337 251.84C75.0627 250.649 75.1947 247.729 75.4297 243.08H75.1657L66.5227 273.871H55.5077Z",
    fill: "#A4A9AD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M125.937 244.662C125.937 249.447 124.526 253.143 121.704 255.751C118.882 258.358 114.873 259.662 109.678 259.662H106.426V273.871H94.8545V231.039H109.678C115.088 231.039 119.151 232.221 121.866 234.584C124.579 236.947 125.937 240.307 125.937 244.662ZM106.425 250.229H108.534C110.272 250.229 111.654 249.741 112.679 248.764C113.704 247.787 114.217 246.44 114.217 244.721C114.217 241.83 112.615 240.385 109.412 240.385H106.424L106.425 250.229Z",
    fill: "#A4A9AD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M158.193 273.871H132.763V231.039H158.193V240.326H144.336V247.064H157.168V256.351H144.336V264.437H158.193V273.871Z",
    fill: "#A4A9AD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M182.891 248.793H201.377V271.879C196.357 273.598 190.84 274.457 184.824 274.457C178.222 274.457 173.12 272.543 169.516 268.715C165.912 264.887 164.111 259.428 164.111 252.338C164.111 245.424 166.084 240.043 170.029 236.195C173.974 232.347 179.502 230.424 186.611 230.424C189.306 230.424 191.85 230.678 194.243 231.186C196.636 231.694 198.721 232.338 200.498 233.12L196.836 242.202C193.75 240.679 190.361 239.917 186.67 239.917C183.291 239.917 180.679 241.016 178.833 243.213C176.987 245.41 176.065 248.55 176.065 252.632C176.065 256.636 176.9 259.689 178.57 261.787C180.24 263.887 182.647 264.936 185.792 264.936C187.511 264.936 189.093 264.77 190.538 264.438V257.729H182.892L182.891 248.793Z",
    fill: "#A4A9AD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.821 50.525H238.346L187.821 0V50.525Z",
    fill: "#D1D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpegVideo);
export default __webpack_public_path__ + "static/media/mpeg-video.07729efd6794c44b897991e12a59bd90.svg";
export { ForwardRef as ReactComponent };